<template>
  <div>
    <FormHeading
      :ordinal="`0${stepNumber}.`"
      :title="step.heading"
      :subtitle="step.subheading"
    />
    <Select
      v-for="addOnName in addOns"
      :key="addOnName"
      :name="`spec.${addOnName}`"
      :options="options[addOnName]"
      :placeholder="$t('common.fieldPlaceholders.select')"
      :label="getFieldLabel(addOnName)"
      :initialValue="initialValues[addOnName]"
    />
    <Input
      name="spec.other_add_on"
      inputType="number"
      :label="getFieldLabel('other_add_on')"
      :placeholder="$t('common.fieldPlaceholders.type_minutes')"
      :initialValue="initialValues.other_add_on"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import estimateFormMixin from '@/common/mixins/estimate-form';
import FormHeading from '@/components/FormHeading';
import { isShape } from '@/common/prop-validators';
import { Input, Select } from '@/components/common';
import { formatOptions } from '@/common/helpers';

const { mapState } = createNamespacedHelpers('estimate');

const addOns = [
  'linen_change',
  'vacuum_furniture',
  'inside_fridge',
  'inside_oven',
  'laundry',
  'inside_windows',
  'inside_cabinets',
  'wet_wipe_blinds',
];

export default {
  name: 'AddOnsForm',
  components: { Input, Select, FormHeading },
  mixins: [estimateFormMixin],
  props: {
    step: {
      type: Object,
      validator: isShape({
        component: Object,
        label: String,
        heading: String,
        id: String,
        subheading: String,
      }),
    },
    stepNumber: {
      type: Number,
    },
  },
  data() {
    return { addOns };
  },
  methods: {
    getFieldLabel(field) {
      return this.$t(`addOns.fieldLabels.${field}`);
    },
  },
  computed: {
    ...mapState({
      initialValues: state => state.current.data.spec || {},
    }),
    options() {
      return addOns.reduce((acc, field) => {
        acc[field] = formatOptions(this.settings.data.spec[field]);
        return acc;
      }, {});
    },
  },
};
</script>
